"use client";
import React from "react";
import type { SnackbarNotification } from "./SnackbarContext";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";

interface SnackbarState {
  open: boolean;
  message: string | SnackbarNotification;
  severity: "success" | "error" | "info";
  onUndo?: () => void;
}

interface Props {
  snackbar: SnackbarState;
  onClose: () => void;
  onUndo: () => void;
}

export const SnackbarRenderer: React.FC<Props> = ({
  snackbar,
  onClose,
  onUndo,
}) => {
  const message = snackbar.message;

  const getMessageText = () =>
    typeof message === "string"
      ? message
      : (message?.message ?? "Notificare nouă");

  const handleButtonClick = async () => {
    if (typeof message !== "string" && typeof message.onClick === "function") {
      try {
        await message.onClick();
      } catch {
        // ignore
      }
    }
    onClose();
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={snackbar.severity}
        icon={
          typeof message !== "string" && message?.icon
            ? message.icon
            : undefined
        }
        sx={{ width: "100%" }}
        action={
          <>
            {snackbar.onUndo ? (
              <Button color="inherit" size="small" onClick={onUndo}>
                Anulează
              </Button>
            ) : null}
            {typeof message !== "string" && message?.buttonLabel ? (
              <Button color="inherit" size="small" onClick={handleButtonClick}>
                {message.buttonLabel}
              </Button>
            ) : null}
          </>
        }
      >
        {getMessageText()}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarRenderer;
